import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safeUrl',
})
export class SafeUrlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(value: string) {
        if (value) {
            return this.sanitizer.bypassSecurityTrustResourceUrl(value);
        }

        return value || '';
    }
}
